import { render, staticRenderFns } from "./DashboardFileUpload.vue?vue&type=template&id=6d3ded07"
import script from "./DashboardFileUpload.vue?vue&type=script&lang=js"
export * from "./DashboardFileUpload.vue?vue&type=script&lang=js"
import style0 from "./DashboardFileUpload.vue?vue&type=style&index=0&id=6d3ded07&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports